import UserModel from '../../models/UserModel';
import moment from 'moment';

export default function getUserModelFromApiReturn(apiReturn) {
  try {
    let _user = UserModel({
      id: apiReturn.data.user.id,
      email: apiReturn.data.user.email,
      name: apiReturn.data.user.name,
      profile: apiReturn.data.user.profile,
      token: apiReturn.data.token,
      refreshToken: apiReturn.data.refreshToken,
      lastTokenDate: moment().format(),
    });

    return _user;
  } catch (error) {
    console.log('Error getUserModelFromApiReturn', error);
    throw error;
  }
}
